import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import delete_icon_add_staff from "assets/images/delete_icon_add_staff.svg";

function DeleteOfficeAssignmentModal({ t, deleteAssignment }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <button
        className="d-flex gap-sm ml-3 highlight-red-color bg-transparent border-0"
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <img src={delete_icon_add_staff} alt="delete icon" />
        Delete
      </button>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className={"modal-dialog-centered modal-width-660"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => setIsModalOpen(false)}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">Delete Office Assigment</span>
          </Text>
          <Text size="16px" marginBottom="10px" weight="400" color="#6f7788">
            Are you sure you want to delete the office assignment?
          </Text>
          <button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            title={t("apply")}
            onClick={deleteAssignment}
          >
            Delete
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link "
            onClick={() => {
              setIsModalOpen(false);
            }}
            title={t("cancel")}
          >
            {t("cancel")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(DeleteOfficeAssignmentModal);
